import React, { FC, JSX } from 'react'

import { TimelineType } from '@interco/inter-ui/components/Timeline'

import { TrackingItemView } from './TrackingItemView'

type TTrackingItemProps = {
  title: string
  type: TimelineType
  content: { content: string; subContent?: string }
  hasVerticalBar?: boolean
  hasActionButton?: boolean
  buttonLabel?: string
  icon: string | undefined
  color: string
  children?: JSX.Element
  pendingReason?: string

  onClick?: () => void
}

export const TrackingItem: FC<TTrackingItemProps> = ({
  title,
  type,
  content,
  hasVerticalBar = true,
  hasActionButton = false,
  buttonLabel = '',
  icon,
  color = 'var(--gray500)',
  children,
  pendingReason,
  onClick,
}) => (
  <TrackingItemView
    title={title}
    type={type}
    content={content}
    hasActionButton={hasActionButton}
    buttonLabel={buttonLabel}
    onClick={onClick}
    icon={icon}
    color={color}
    hasVerticalBar={hasVerticalBar}
    pendingReason={pendingReason}
  >
    {children && children}
  </TrackingItemView>
)
